import {Injectable} from '@angular/core';
import {RequesterService} from '../../../services/requester.service';
import {JourneyPageModel} from '../models/journey-page.model';
import {MyDiaryUpdateRequestModel, ProgramDelegateModel, UserDiaryUpdateRequestModel} from '../models/program.model';
import {RequesterResponseModel} from '../../../services/models/requester.model';
import {TasksModel} from '../../tasks/models/tasks.model';
import {RequesterServerService} from '../../../services/requester-server.service';

@Injectable({
    providedIn: 'root'
})
export class JourneyService {
    constructor(
      private requesterService: RequesterService,
      private requesterServerService: RequesterServerService
    ) {
    }

    getJourneyTypes() {
        return ['list', 'text', 'program'];
    }

    getStageData(stage_id: number, template_id: number): Promise<JourneyPageModel> {
        return this.requesterService.get('getMyJourneyStage', {stage_id, template_id})
            .then(data => {
                if (!!data.result) {
                    return data.result;
                }
                return null;
            })
            .catch(e => {
                console.log('Error getMyJourneyStage >> ', e);
                return null;
            });
    }


    getPageData(stage: number, template_id: number): Promise<JourneyPageModel> {
        return this.requesterService.get('getMyJourneyStage', {stage, template_id})
            .then(data => {
                if (!!data.result) {
                    return data.result;
                }
                return null;
            })
            .catch(e => {
                console.log('Error getMyJourneyStage >> ', e);
            });
    }

    savePageData(list: Array<any>): Promise<RequesterResponseModel> {
        return this.requesterService.post('saveMyJourneyStage', list)
            .then(data => {
                return data.result;
            })
            .catch(e => {
                return null;
                console.log('Error saveMyJourneyStage >> ', e);
            });
    }

    getMyTask(task_id: number): Promise<TasksModel> {
        return this.requesterService.get('getMyTask', {task_id})
            .then(data => {
                if (!!data.result) {
                    return data.result;
                }
                return null;
            })
            .catch(e => {
                console.log('Error getMyTask >> ', e);
                return null;
            });
    }

    getUserDiary(id: number): Promise<ProgramDelegateModel> {
        return this.requesterService.get('getUserDiary', {prog_del_id: id})
            .then(data => {
                if (!!data.result) {
                    return data.result;
                }
                return null;
            })
            .catch(e => {
                console.log('Error getUserDiary >> ', e);
                return null;
            });
    }

    updateMyDiary(model: MyDiaryUpdateRequestModel): Promise<RequesterResponseModel> {
        return this.requesterService.put('updateMyDiary', model)
            .then(data => {
                return data.result;
            })
            .catch(e => {
                console.error('Error in: updateMyDiary', e);
                return null;
            });
    }

    updateMyDiaryAttendance(pDelegateId: number, attendance: boolean): Promise<RequesterResponseModel> {
        const model = {
            prog_del_id: pDelegateId,
            attend_need: attendance
        };
        return this.requesterService.put('updateMyDiaryAttendance', model)
            .then(data => {
                return data.result;
            })
            .catch(e => {
                console.error('Error in: updateMyDiary', e);
                return null;
            });
    }

    updateUserDiary(model: UserDiaryUpdateRequestModel): Promise<RequesterResponseModel> {
        return this.requesterService.put('updateUserDiary', model)
            .then(data => {
                return data.result;
            })
            .catch(e => {
                console.error('Error in: updateMyDiary', e);
                return null;
            });
    }

    deleteMyJourneyFile(sectionId: number, delId: number): Promise<{ status: boolean, message: string }> {
        return this.requesterServerService.post('deleteMyJourneyFile', {section_id: sectionId, del_id: delId})
            .then(ret => {
                if (!!ret.result && !!ret.result.status && ret.result.status === 'ok') {
                    return {status: true, message: ret.result.message};
                }
                return {status: false, message: ret.error.errorMessage};
            })
            .catch(e => {
                // throw e;
                console.log('Error in deleteMyJourneyFile >> ', e);
                return {status: false, message: 'Error in deleteMyJourneyFile'};
            });
    }
}
